<div
  class="cet-media-scroller hide-scroll"
  [class.snap-inline]="snap"
  #scrollContainer
  style="overflow: auto"
  (wheel)="onScroll($event)"
>
  <ng-content></ng-content>
  <div class="dummy" #dummy *ngIf="!rowScroller"></div>
</div>
<div class="navigator" *ngIf="navigator && numberOfItems > 1">
  <ng-container *ngIf="isScrollable && !rowScroller">
    <span
      *ngFor="let input of [].constructor(arrayLength); let i = index"
      [class.active]="i == activeItem"
      (click)="scrollTo(i)"
    >
    </span>
  </ng-container>
  <ng-container *ngIf="isScrollable && rowScroller">
    <span
      *ngFor="let input of [].constructor(numberOfRows); let i = index"
      [class.active]="i == activeRow"
      (click)="scrollToRow(i)"
    >
    </span>
  </ng-container>
</div>
